export function toHiragana(value: string): string {
  return value.normalize("NFKC").replace(/[ァ-ヶヽヾ]/g, (character) =>
    String.fromCodePoint(character.codePointAt(0)! - 0x60)
  );
}
